<tt-page *ngIf="!!menu">
    <tt-card class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <ng-container *ngTemplateOutlet="info"></ng-container>
        <ng-container *ngTemplateOutlet="buttons"></ng-container>
    </tt-card>

    <div class="col-xs-12 sp-0" *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-card class="col-xs-12 col-md-4 p-5" ttHeading="h_info">
            <ng-container *ngTemplateOutlet="info"></ng-container>
        </tt-card>

        <tt-card class="col-xs-12 col-md-4 p-5" ttHeading="h_functions">
            <ng-container *ngTemplateOutlet="buttons"></ng-container>
        </tt-card>
    </div>
</tt-page>

<ng-template #info>
    <ng-container *ngIf="!!menu">
        <tt-input ttLabel="trextype_id" [ttModel]="menu.trextype_id" ttReadonly></tt-input>
        <tt-input ttLabel="trextype_lang_name" [ttModel]="menu.trextype_lang_name" ttReadonly></tt-input>
        <tt-input ttLabel="activestatus" [ttModel]="menu.activestatus" ttReadonly></tt-input>
    </ng-container>
</ng-template>

<ng-template #buttons>
    <ng-container *ngIf="!!menu">
        <tt-button-goto [ttText]="'travexptypemenu_edit'" [ttGoto]="'travexptype'" [ttGotoParms]="{ trextype_id: menu.trextype_id }"></tt-button-goto>
        <tt-button-goto [ttText]="'travexptypemenu_travexptypebuscos'" [ttGoto]="'travexptypebuscos'" [ttGotoParms]="{ trextype_id: menu.trextype_id }"></tt-button-goto>
        <tt-button ttText="travexptypemenu_delete" (ttClick)="deleteValues()" ttIcon="fas fa-trash-alt" ttType="danger" [ttLoading]="deleting"></tt-button>
    </ng-container>
</ng-template>

<!--<tt-page class="col-xs-12 sp-0" ng-if="vm.model.tabletSize.matches === false">
    <tt-card class="col-xs-12 sp-0">
        <tt-input class="col-xs-12 sp-0" tt-label="trextype_id" tt-model="vm.model.menu.trextype_id" tt-change="vm.model.menu.trextype_id = $value" tt-readonly="true"></tt-input>
        <tt-input class="col-xs-12 sp-0" tt-label="trextype_lang_name" tt-model="vm.model.menu.trextype_lang_name" tt-change="vm.model.menu.trextype_lang_name = $value" tt-readonly="true"></tt-input>
        <tt-input class="col-xs-12 sp-0" tt-label="activestatus" tt-model="vm.model.menu.activestatus" tt-change="vm.model.menu.activestatus = $value" tt-readonly="true"></tt-input>
        <tt-button-goto class="col-xs-12 sp-0" tt-text="travexptypemenu_edit" tt-goto="travexptype" tt-goto-parms="{ trextype_id: vm.model.menu.trextype_id }" tt-text-align="left"></tt-button-goto>
        <tt-button-goto class="col-xs-12 sp-0" tt-text="travexptypemenu_travexptypebuscos" tt-goto="travexptypebuscos" tt-goto-parms="{ trextype_id: vm.model.menu.trextype_id }" tt-text-align="left"></tt-button-goto>
        <tt-button class="col-xs-12 sp-0" tt-text="travexptypemenu_delete" tt-locked="vm.model.lockedDelete" tt-click="vm.deleteValues()" tt-icon="fas fa-trash-alt" tt-type="danger" tt-text-align="center"></tt-button>
    </tt-card>
</tt-page>

<tt-page class="col-xs-12 sp-0" ng-if="vm.model.tabletSize.matches === true">
    <div class="col-xs-12 sp-0">
        <tt-card class="col-xs-12 col-md-4 p-5">
            <tt-page-heading class="col-xs-12 sp-0" tt-model="h_info" tt-translate="true"></tt-page-heading>
            <div class="k-hr col-xs-12 sp-0"></div>
            <tt-input class="col-xs-12 sp-0" tt-label="trextype_id" tt-model="vm.model.menu.trextype_id" tt-change="vm.model.menu.trextype_id = $value" tt-readonly="true"></tt-input>
            <tt-input class="col-xs-12 sp-0" tt-label="trextype_lang_name" tt-model="vm.model.menu.trextype_lang_name" tt-change="vm.model.menu.trextype_lang_name = $value" tt-readonly="true"></tt-input>
            <tt-input class="col-xs-12 sp-0" tt-label="activestatus" tt-model="vm.model.menu.activestatus" tt-change="vm.model.menu.activestatus = $value" tt-readonly="true"></tt-input>
        </tt-card>

        <tt-card class="col-xs-12 col-md-4 p-5">
            <tt-page-heading class="col-xs-12 sp-0" tt-model="h_functions" tt-translate="true"></tt-page-heading>
            <div class="k-hr col-xs-12 sp-0"></div>
            <tt-button-goto class="col-xs-12 sp-0" tt-text="travexptypemenu_edit" tt-goto="travexptype" tt-goto-parms="{ trextype_id: vm.model.menu.trextype_id }" tt-text-align="left"></tt-button-goto>
            <tt-button-goto class="col-xs-12 sp-0" tt-text="travexptypemenu_travexptypebuscos" tt-goto="travexptypebuscos" tt-goto-parms="{ trextype_id: vm.model.menu.trextype_id }" tt-text-align="left"></tt-button-goto>
            <tt-button class="col-xs-12 sp-0" tt-text="travexptypemenu_delete" tt-locked="vm.model.lockedDelete" tt-click="vm.deleteValues()" tt-icon="fas fa-trash-alt" tt-type="danger" tt-text-align="center"></tt-button>
        </tt-card>
    </div>
</tt-page>-->
